/**
 * Side-effect module: must be imported from index.ts BEFORE `./App` so
 * react-native-toast-message (BaseToast.styles shadow* props) and other
 * early web noise is filtered before those modules evaluate.
 */
import { Platform } from 'react-native';

if (Platform.OS === 'web') {
  const originalWarn = console.warn.bind(console);
  const originalError = console.error.bind(console);
  const originalLog = console.log.bind(console);
  const ignoredWebWarnings = [
    '"shadow*" style props are deprecated. Use "boxShadow".',
    'style props are deprecated. Use "boxShadow"',
    'props.pointerEvents is deprecated. Use style.pointerEvents',
    '[SQLite] Invalid VFS state detected; reopening persistent DB.',
    '[SQLite] DB disabled for this session due to Invalid VFS state. Close all app tabs and reload.',
    '[BranchesCache] Error al guardar caché:',
    '[BranchesCache] Error al leer caché:',
    // Diagnóstico opcional (EXPO_PUBLIC_DEBUG_SERVICE_FETCHES); React DevTools lo muestra como installHook.
    '[globalFeatureFlags] fetchGlobalFeatureFlags llamado desde:',
    '[globalFeatureFlags] retornando cache',
    '[globalFeatureFlags] coalescando con in-flight',
    '[branches] fetchUserBranches llamado desde:',
    '[branches] retornando cache',
    '[branches] coalescando con in-flight',
    '[planEntitlements] fetchMyOrganizationEntitlements llamado desde:',
    '[planEntitlements] retornando cache',
    '[planEntitlements] coalescando con in-flight',
    // Web sin módulo nativo de animación (p. ej. dependencias con useNativeDriver: true).
    'native animated module is missing',
  ];
  const ignoredWebLogs = [
    'Running application "main" with appParams:',
    '[fiadoPullApplication] Snapshot remoto OK; apply SQLite omitido en web',
    '[catalogSnapshot] Snapshot remoto OK; apply SQLite omitido en web',
  ];

  const shouldIgnoreMessage = (args: unknown[], patterns: string[]) =>
    args.some((value) => typeof value === 'string' && patterns.some((message) => value.includes(message)));

  console.warn = (...args: unknown[]) => {
    if (shouldIgnoreMessage(args, ignoredWebWarnings)) {
      return;
    }
    originalWarn(...args);
  };

  console.error = (...args: unknown[]) => {
    if (shouldIgnoreMessage(args, ignoredWebWarnings)) {
      return;
    }
    originalError(...args);
  };

  console.log = (...args: unknown[]) => {
    if (shouldIgnoreMessage(args, ignoredWebLogs)) {
      return;
    }
    originalLog(...args);
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
      const reason = event.reason as { name?: string; message?: string } | undefined;
      if (
        reason?.name === 'DatabaseUnavailableError' ||
        reason?.name === 'InvalidStateError' ||
        reason?.message?.includes('Invalid VFS state') ||
        reason?.message?.includes('catalog load invalidated')
      ) {
        event.preventDefault();
      }
    });

    if (typeof document !== 'undefined') {
      const blurFocusedInsideAriaHidden = () => {
        const active = document.activeElement;
        if (active && active instanceof HTMLElement) {
          const hiddenAncestor = active.closest('[aria-hidden="true"]');
          if (hiddenAncestor) active.blur();
        }
      };
      const ariaHiddenObserver = new MutationObserver(blurFocusedInsideAriaHidden);
      ariaHiddenObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true,
      });
      blurFocusedInsideAriaHidden();
    }
  }
}
